import { OrderEditDiscount } from '../components/Products';

export function useEditOrderDiscountActions(
  editedOrderDiscounts: OrderEditDiscount[],
  setEditedOrderDiscounts: (editedDiscounts: OrderEditDiscount[]) => void,
  isOrderEdited: boolean,
  setIsOrderEdited: (isEdited: boolean) => void,
) {
  const handleUpdateDiscounts = (discounts: OrderEditDiscount[]) => {
    const updatedDiscounts = discounts
      .map((d) => {
        if (d.id === 'editCouponDiscount' && d.editType === 'remove') {
          return;
        }

        const originalDiscount = editedOrderDiscounts.find(
          (ed) => ed.id === d.id && ed.id !== 'editCouponDiscount',
        );
        if (d.editType === 'add' && originalDiscount !== undefined) {
          return {
            ...d,
            editType: undefined,
          };
        }

        return d;
      })
      .filter((d): d is OrderEditDiscount => d !== undefined);

    setEditedOrderDiscounts(updatedDiscounts);
    updateIsOrderDiscountsEdited(updatedDiscounts);
  };

  const updateIsOrderDiscountsEdited = (discounts: OrderEditDiscount[]) => {
    const isEdited = discounts.some((p) => p.editType !== undefined);
    if (isOrderEdited !== isEdited) {
      setIsOrderEdited(isEdited);
    }
  };

  return {
    handleUpdateDiscounts,
    isOrderEdited,
  };
}
